import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getPosts } from "../lib/data";
import { Reveal } from "../components/Reveal";
import { usePageMeta } from "@/hooks/use-page-meta";

export default function Blog() {
  usePageMeta({ title: "Blog", description: "Kurumsal araç kiralama, filo yönetimi ve vergi avantajları üzerine VIA PRIME Luxury yazıları." });
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPosts().then((p) => {
      setPosts(p);
      setLoading(false);
    });
  }, []);

  return (
    <div className="py-20 px-6" data-testid="blog-page">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <span className="text-xs font-mono-lbl uppercase tracking-widest text-[#8F7648]">
            Editöryal
          </span>
          <h1 className="text-4xl md:text-6xl font-serif-display text-[#404040] mt-2">
            Güncel Yazılar
          </h1>
          <p className="text-sm text-[#6B6B6B] mt-4 max-w-xl">
            Kurumsal filo yönetimi ve lüks araç dünyasından içgörüler.
          </p>
        </Reveal>

        {loading ? (
          <div className="mt-16 text-[#6B6B6B] text-sm font-mono-lbl" data-testid="blog-loading">
            Yazılar yükleniyor...
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
            {posts.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.1}>
                <Link
                  to={`/blog/${p.slug}`}
                  data-testid={`blog-post-card-${p.slug}`}
                  className="group block rounded-sm bg-white shadow-[0_4px_20px_rgba(176,144,96,0.05)] border border-[#B09060]/20 overflow-hidden hover:border-[#B09060]/50 transition-colors h-full"
                >
                  <div className="h-48 overflow-hidden">
                    <img
                      src={p.image_url}
                      alt={p.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-6">
                    <div className="text-[10px] font-mono-lbl uppercase tracking-widest text-[#9B9B8F]">
                      {new Date(p.created_at).toLocaleDateString("tr-TR")}
                    </div>
                    <h3 className="text-base font-bold text-[#404040] leading-snug mt-2 group-hover:text-[#8F7648] transition-colors">
                      {p.title}
                    </h3>
                    <p className="text-xs text-[#6B6B6B] mt-2 leading-relaxed line-clamp-3">
                      {p.excerpt}
                    </p>
                    <span className="inline-flex items-center gap-2 text-[10px] font-mono-lbl uppercase tracking-widest text-[#8F7648] mt-4">
                      Devamını Oku <ArrowRight className="w-3 h-3" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
